import { render, staticRenderFns } from "./order-expand.vue?vue&type=template&id=722233d8&scoped=true&"
import script from "./order-expand.vue?vue&type=script&lang=js&"
export * from "./order-expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722233d8",
  null
  
)

export default component.exports